import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=0c7997a7&scoped=true"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=0c7997a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7997a7",
  null
  
)

export default component.exports